import React, { useContext, useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Header from './components/Header/Header';
import Navigation from './components/Navigation/Navigation';
import BackNavigation from './components/Navigation/BackNavigation';
import HomePage from './pages/HomePage';
import BasicInfoPage from './pages/BasicInfoPage';
import ManufacturingEnvironmentPage from './pages/ManufacturingEnvironmentPage';
import MaintenancePage from './pages/MaintenancePage';
import HistoryPage from './pages/HistoryPage';
import { DataContext } from './contexts/DataContext';
import LoadingSpinner from './components/LoadingSpinner/LoadingSpinner';

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { loading } = useContext(DataContext);

  const pageId =
    location.pathname === '/' ? 'home' :
    location.pathname === '/basicinfo' ? 'basic-info' :
    location.pathname === '/manufacturing-environment' ? 'manufacturing-environment' :
    location.pathname === '/maintenance' ? 'maintenance' :
    location.pathname.includes('/history') ? 'history' :
    'default';

  // QRコードのクエリパラメータを sessionStorage に保存・復元
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const qr = params.get('qr');

    if (!qr) {
      const savedQr = sessionStorage.getItem('qr');
      if (savedQr) {
        params.set('qr', savedQr);
        navigate(`${location.pathname}?${params.toString()}`, { replace: true });
      }
    } else {
      sessionStorage.setItem('qr', qr);
    }
  }, [location, navigate]);

  // langパラメータがある場合はi18nを切り替え
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const lang = params.get('lang');
    if (lang && ['ja', 'en', 'zh'].includes(lang)) {
      i18n.changeLanguage(lang);
      localStorage.setItem('i18nextLng', lang);
    }
  }, [location.search, i18n]);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div id={pageId}>
      <div className="container">
        <Header />
        {pageId === 'history' ? (
          <BackNavigation backLink="/maintenance" />
        ) : (
          <Navigation currentPage={location.pathname} />
        )}
        <main className="container-inner">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/basicinfo" element={<BasicInfoPage />} />
            <Route path="/manufacturing-environment" element={<ManufacturingEnvironmentPage />} />
            <Route path="/maintenance" element={<MaintenancePage />} />
            <Route path="/maintenance/history/:type" element={<HistoryPage />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default App;
